import type { User } from "@tabipla/shared/domain";
import type { ApiClientInterface } from "../infrastructure/api-client";

/**
 * アバター情報DTO
 */
export interface AvatarInfoDto {
  avatarEmoji: string | null;
  avatarColor: string | null;
  image: string | null;
}

/**
 * ユーザーレスポンスDTO
 */
export interface UserResponseDto {
  id: string;
  email: string;
  name: string;
  emailVerified: boolean;
  image: string | null;
  createdAt: string;
  updatedAt: string;
}

/**
 * アバター更新入力
 */
export interface UpdateAvatarInput {
  avatarEmoji: string | null;
  avatarColor: string | null;
}

/**
 * プロフィール更新入力
 */
export interface UpdateProfileInput {
  name: string;
}

/**
 * useProfileCore のオプション
 */
export interface UseProfileCoreOptions {
  /** APIクライアント */
  apiClient: ApiClientInterface;
  /** ユーザーIDを取得する関数 */
  getUserId: () => string | null;
  /** 現在のユーザーを取得する関数 */
  getUser: () => User | null;
  /** ユーザー状態を更新する関数 */
  setUser: (user: User | null) => void;
  /** 追加のクエリ無効化キー（アプリ固有） */
  additionalInvalidateKeys?: string[][];
}

/**
 * DTOからドメインUserへ変換
 */
export function toUser(dto: UserResponseDto): User {
  return {
    id: dto.id,
    email: dto.email,
    name: dto.name,
    emailVerified: dto.emailVerified,
    image: dto.image ?? undefined,
    createdAt: new Date(dto.createdAt),
    updatedAt: new Date(dto.updatedAt),
  };
}
